import React, { useContext } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useGetFiles } from '@widgets/Files/hooks/useGetFiles';
import { ContextFiles } from '@widgets/Files/model/context';

import cls from './EmptyFilesList.module.css';

export const EmptyFilesList = () => {
    const { t } = useTranslation();
    const { currentFolderId } = useContext(ContextFiles);
    const { isFetching } = useGetFiles(currentFolderId);

    if (isFetching) {
        return null;
    }
    return (
        <div className={classNames(cls.EmptyFilesList)}>
            {currentFolderId === 0 || currentFolderId === null ? (
                <h1>{t('EmptyFilesList.return.title')}</h1>
            ) : (
                <h1>{t('EmptyFilesList.folder.return.title')}</h1>
            )}
            {/* <h1>{t('EmptyFilesList.return.title')}</h1> */}
            {currentFolderId === 0 ? (
                <p>
                    {t('EmptyFilesList.return.description.part1')}
                    <br />
                    {t('EmptyFilesList.return.description.part2')}
                </p>
            ) : (
                <p>
                    {t('EmptyFilesList.folder.return.description.part1')}
                    <br />
                    {t('EmptyFilesList.folder.return.description.part2')}
                </p>
            )}
        </div>
    );
};
